import { useEffect, useState } from 'react';

import { BREAKPOINTS } from 'constants/index';

interface WindowSizeStateType {
  width: number;
  height: number;
}

interface UseWindowSizeProps {
  initialWidth?: number;
  initialHeight?: number;
}

export const useWindowSize = (props?: UseWindowSizeProps) => {
  const [windowSize, setWindowSize] = useState<WindowSizeStateType>({
    width: props?.initialWidth ?? window.innerWidth,
    height: props?.initialHeight ?? window.innerHeight,
  });
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    ...windowSize,
    isMobileX: windowSize.width <= BREAKPOINTS.mobile,
    isMobile: windowSize.width <= BREAKPOINTS.web,
    isDesktop: windowSize.width >= BREAKPOINTS.desktop,
    isMacAir: windowSize.width <= BREAKPOINTS.MacAir,
  };
};
